import React from 'react';

interface ButtonProps {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
}

const ButtonMore: React.FC<ButtonProps> = ({ text, onClick, disabled = false }) => {
  return (
    <button className={'button-more '} onClick={onClick} disabled={disabled}>
      <div className="flex-row align-center">
        <span className="button-more-plus">+</span>
        {text}
      </div>
    </button>
  );
};

export default ButtonMore;
